module.exports = __webpack_public_path__ + "static/media/play_store.ac5f16f0.svg";